import { useTranslation } from 'react-i18next'
import { useGetInvestigators } from '@/application/services/user.service'
import { AvatarSkeleton } from './AvatarSkeleton'
import { InvestigatorCard } from './InvestigatorCard'

/**
 * Investigators grid section for the public investigators page.
 * Owns the data fetching, loading skeleton, empty state, and the
 * responsive card grid rendering each investigator.
 */
export function InvestigatorsGridSection() {
  const { t } = useTranslation()
  const { data: investigators, isLoading } = useGetInvestigators()

  if (isLoading) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {Array.from({ length: 10 }).map((_item, index) => (
          <AvatarSkeleton key={index} />
        ))}
      </div>
    )
  }

  if (!investigators || investigators.length === 0) {
    return (
      <div className="text-center py-16 text-muted-foreground border border-border rounded-lg">
        <p>{t('investigators.empty')}</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
      {investigators.map((investigator) => (
        <InvestigatorCard key={investigator.id} inv={investigator} />
      ))}
    </div>
  )
}
